import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IVisitSlotSearchRequest, IVisitSlot } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class VisitSlotsService {
  private readonly http = inject(HttpClient);

  getVisitSlots(salonId: string, searchRequest: IVisitSlotSearchRequest): Observable<IVisitSlot[]> {
    return this.http.post<IVisitSlot[]>(`/api/visitSlots/${salonId}/slots`, searchRequest);
  }
}
